__turbopack_context__.v({
  "fallbackContainer": "fallback-module-scss-module__XEo1Rq__fallbackContainer",
  "messageWrapper": "fallback-module-scss-module__XEo1Rq__messageWrapper",
  "reloadIcon": "fallback-module-scss-module__XEo1Rq__reloadIcon",
  "reloadLink": "fallback-module-scss-module__XEo1Rq__reloadLink",
});
